import { logLoginApi, logLogoutApi } from '@core/core/api'
import type { ParsedToken } from '@library/token'
import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import type { Nullable } from 'common/types'

const initialState: { user: Nullable<ParsedToken> } = {
  user: null,
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserInfo: (state, { payload }: PayloadAction<Nullable<ParsedToken>>) => {
      state.user = payload
    },
    userLogout: () => {
      logLogoutApi()
    },
  },
})

export default userSlice.reducer
